export const calculateOrbitPeriodSeconds = (altitudeKm: number): number => {
    const EARTH_RADIUS_KM = 6371;
    const MU = 3.986004418e14;

    const semiMajorAxisMeters = (EARTH_RADIUS_KM + altitudeKm) * 1000;

    const periodSeconds = 2 * Math.PI * Math.sqrt(Math.pow(semiMajorAxisMeters, 3) / MU);

    return periodSeconds;
}
